
import {
  HotLabEquipmentDto,
  CreateHotLabEquipmentDto,
  UpdateHotLabEquipmentDto,
  HotLabEquipmentType,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type HotLabEquipmentsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
  search?: string
  type?: HotLabEquipmentType
  types?: HotLabEquipmentType[]
  isConfigurable?: boolean
  excludeAssignedToWorkbench?: boolean
  excludeAssignedToWorkbenchExceptId?: string
}

class HotLabEquipmentService extends BaseCrudService<
  HotLabEquipmentDto,
  CreateHotLabEquipmentDto,
  UpdateHotLabEquipmentDto,
  HotLabEquipmentsFilters
> {
  constructor() {
    super('hot-lab-equipment', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const hotLabEquipmentService = new HotLabEquipmentService()
